import * as React from 'react';
import { IReportingUser } from '../../models';

export interface IReportingAccessLoaderProps {
	surveyId: number;
	isLoadingUsers: boolean;
	reportingUsers: IReportingUser[];
	GetUsers: (surveyId: number) => void;
}

export class ReportingAccessLoader extends React.Component<IReportingAccessLoaderProps> {
	public componentDidMount() {
		this.props.GetUsers(this.props.surveyId);
	}

	public UNSAFE_componentWillReceiveProps(nextProps: IReportingAccessLoaderProps) {
		if (this.props.reportingUsers === undefined || (this.props.reportingUsers.length === 0 && !this.props.isLoadingUsers)) {
			this.props.GetUsers(this.props.surveyId);
		}
	}

	public render() {
		return <></>;
	}
}
